import React from 'react';

/**
 * 受付時間超過（便単位で選択不可）の便に対して、運賃ボタン群の領域全体を
 * 1つのグレーボックスに置き換えて表示するコンポーネント。
 */
const SameDayUnavailableBox: React.FC = () => {
  const styles = getStyles();
  return <div style={styles.box}>受付時間を過ぎているため予約できません</div>;
};

const getStyles = () => ({
  box: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    width: '100%',
    minHeight: '48px',
    padding: '12px',
    background: '#f8f8f8',
    color: '#999999',
    fontSize: '12px',
    lineHeight: 1.5
  } as const
});

export default SameDayUnavailableBox;
